import React from "react";
import { MobileNavigation } from "../Navigation/Mobile";
import SideBar from "../Navigation/Desktop";

const Header = (props) => {
  return (
    <>
      <SideBar badgeCount={props.badgeCount} memberTypeObj={props.memberObj} />
      <MobileNavigation
        badgeCount={props.badgeCount}
        memberTypeObj={props.memberObj}
        logoutUser={props.logoutUser}
      />
    </>
  );
};

export default Header;
